__turbopack_context__.v({
  "icon": "IconPosition-module-scss-module__YEBRyW__icon",
});
